import I18n from "components/materials/I18n";
import classes from "./classes.module.scss";
import classNames from "classnames";
import { CalendarIcon } from "@heroicons/react/20/solid";
import Typography from "components/elements/Typography";

type IProps = {
	endDate: Date;
};

enum EVoteTagType {
	IN_PROGRESS = "in_progress",
	ENDED = "ended",
}

export default function VoteTag(props: IProps) {
	return (
		<div className={classNames(classes["root"], classes[getVoteTagType(props.endDate)])}>
			<CalendarIcon className={classes["icon"]} />
			<Typography type="p" size="small" weight="medium" className={classes["text"]}>
				{getVoteTagText(props.endDate)}
			</Typography>
		</div>
	);
}

function getVoteTagType(date: Date): EVoteTagType {
	const now = new Date();
	if (date < now) {
		return EVoteTagType.ENDED;
	}
	return EVoteTagType.IN_PROGRESS;
}

function getVoteTagText(date: Date) {
	const type = getVoteTagType(date);
	switch (type) {
		case EVoteTagType.ENDED:
			return I18n.asset.pages.professional_space.tabs.votes.tags.ended;
		case EVoteTagType.IN_PROGRESS:
			const dayLeft = getDaysLeft(date);
			return `${dayLeft} ${I18n.asset.pages.professional_space.tabs.votes.tags.in_progress}${dayLeft > 1 ? "s" : ""}`;
	}
}

function getDaysLeft(endDate: Date): number {
	const now = new Date();

	now.setHours(0, 0, 0, 0);
	endDate.setHours(0, 0, 0, 0);

	const difference = endDate.getTime() - now.getTime();

	return Math.ceil(difference / (1000 * 60 * 60 * 24));
}
